export default "/images/vendor/flag-icon-css/flags/1x1/tf.svg?90c38a9f431cbad5c55862c20ee7b936";